import { PkSpinner } from '@uefadigital/panenka-react';

export const Loader = () => (
  <div className='ts-loader'>
    <PkSpinner />
  </div>
);

export default Loader;
